export default __webpack_public_path__ + "static/media/BIRDDOGS_Logo.c31c5174.png";